import { createAction } from '@reduxjs/toolkit';

export const onClickBtnCreate = createAction('onClickBtnCreate')